// logGenerator.js

export const logGenerator = (type, message) => {
    const timestamp = new Date().toISOString();
    
    // Fetch current logs from localStorage
    const currentLogs = JSON.parse(localStorage.getItem('auditLogs')) || [];
  
    // Create new log entry
    const newLog = {
      type: type.toUpperCase(),
      message,
      timestamp,
    };
  
    // Append the new log to the existing logs
    const updatedLogs = [newLog, ...currentLogs];
  
    // Save back to localStorage
    localStorage.setItem('auditLogs', JSON.stringify(updatedLogs));
    
    console.log(`[${newLog.type}] ${newLog.timestamp} - ${newLog.message}`);
  };
  